import { Col } from 'antd';
import { FormattedMessage } from 'react-intl';
import { snakeCase } from 'lodash-es';

import { LabelRow } from '../../components/typography';
import { CurrencyFormat } from '../../components/domainSpecific/currencyElements';

export function ShipmentChargesContent({
  charges,
  currency,
  rowClassName,
  nameColSpan,
  amountColSpan,
}) {
  if (!charges?.items?.length) {
    return null;
  }

  return (
    <>
      {charges.items.map(item => (
        <LabelRow noBorder key={snakeCase(item.name)} className={rowClassName}>
          <Col span={nameColSpan}>{item.name}</Col>
          <Col span={amountColSpan}>
            <CurrencyFormat currency={currency} value={item.amount} />
          </Col>
        </LabelRow>
      ))}
      <LabelRow noBorder className={rowClassName}>
        <Col span={nameColSpan}>
          <FormattedMessage id="shipmentDetail.charges.total" />
        </Col>
        <Col span={amountColSpan}>
          <CurrencyFormat currency={currency} value={charges.total} />
        </Col>
      </LabelRow>
    </>
  );
}
